export enum MqttTopic {
  CONTROLLER_HAS_OVERCURRENT = 'bikefitting/Controller/hasOvercurrent',
  CONTROLLER_HAS_STALLED = 'bikefitting/Controller/hasStalled',
  CONTROLLER_MOTOR_STATE = 'bikefitting/Controller/motorState',
  CONTROLLER_OTA_SET = 'bikefitting/Controller/allowOTA/set',
  CONTROLLER_OTA_UNSET = 'bikefitting/Controller/allowOTA/unset',
  CONTROLLER_OTA_UPDATE = 'bikefitting/Controller/otaUpdate',
  CONTROLLER_REBOOT_SET = 'bikefitting/Controller/reboot/set',
  CONTROLLER_SHUTDOWN_SET = 'bikefitting/Controller/shutdown/set',
  CONTROLLER_TEMPERATURE = 'bikefitting/Controller/temperature',
  CONTROLLER_VERSION = 'bikefitting/Controller/version',
  CONTROLLER_DEVICES_REFRESH = 'bikefitting/Controller/refresh/set',
  CRANKSET_ACCUMULATED_POWER = 'bikefitting/crankset/accumulated_power',
  CRANKSET_CADENCE = 'bikefitting/crankset/cadence',
  CRANKSET_INSTANTANEOUS_POWER = 'bikefitting/crankset/instantanious_power',
  CRANKSET_LEFT_SMOOTHNESS = 'bikefitting/crankset/left_smoothness',
  CRANKSET_LEFT_TORQUE = 'bikefitting/crankset/left_torque',
  CRANKSET_PEDAL_DIFF = 'bikefitting/crankset/pedal_diff',
  CRANKSET_PEDAL_RATIO = 'bikefitting/crankset/pedal_ratio',
  CRANKSET_RIGHT_SMOOTHNESS = 'bikefitting/crankset/right_smoothness',
  CRANKSET_RIGHT_TORQUE = 'bikefitting/crankset/right_torque',
  DEVICES_ANT_CONNECT = 'bikefitting/devices/ant/connect',
  DEVICES_ANT_LIST = 'bikefitting/devices/ant/list',
  DEVICES_BLE_CONNECT = 'bikefitting/devices/ble/connect',
  DEVICES_BLE_LIST = 'bikefitting/devices/ble/list',
  HEARTRATE_ACCUMULATED_EVENTTIME = 'bikefitting/heartrate/accumulated_eventtime',
  HEARTRATE_HEART_RATE = 'bikefitting/heartrate/heart_rate',
  HEARTRATE_RR_TIME = 'bikefitting/heartrate/rr_time',
  MOTORCONTROLLER_HANDLEBAR_X_CURRENT_POS = 'bikefitting/motorcontroller/2/current_pos',
  MOTORCONTROLLER_HANDLEBAR_X_CURRENT_SETPOINT = 'bikefitting/motorcontroller/2/current_setpoint',
  MOTORCONTROLLER_HANDLEBAR_X_STATUS = 'bikefitting/motorcontroller/2/status',
  MOTORCONTROLLER_HANDLEBAR_Y_CURRENT_POS = 'bikefitting/motorcontroller/3/current_pos',
  MOTORCONTROLLER_HANDLEBAR_Y_CURRENT_SETPOINT = 'bikefitting/motorcontroller/3/current_setpoint',
  MOTORCONTROLLER_HANDLEBAR_Y_STATUS = 'bikefitting/motorcontroller/3/status',
  MOTORCONTROLLER_SADDLE_X_CURRENT_POS = 'bikefitting/motorcontroller/0/current_pos',
  MOTORCONTROLLER_SADDLE_X_CURRENT_SETPOINT = 'bikefitting/motorcontroller/0/current_setpoint',
  MOTORCONTROLLER_SADDLE_X_STATUS = 'bikefitting/motorcontroller/0/status',
  MOTORCONTROLLER_SADDLE_Y_CURRENT_POS = 'bikefitting/motorcontroller/1/current_pos',
  MOTORCONTROLLER_SADDLE_Y_CURRENT_SETPOINT = 'bikefitting/motorcontroller/1/current_setpoint',
  MOTORCONTROLLER_SADDLE_Y_STATUS = 'bikefitting/motorcontroller/1/status',
  MOTORCONTROLLER_HOMING_SET = 'bikefitting/motorcontroller/set/homing',
  MOTORCONTROLLER_START = 'bikefitting/motorcontroller/start',
  MOTORCONTROLLER_STOP = 'bikefitting/motorcontroller/stop',
  MOTORCONTROLLER_RESET = 'bikefitting/motorcontroller/reset',
  RESISTANCE_ACCUMULATED_POWER = 'bikefitting/resistance/accumulated_power',
  RESISTANCE_DISTANCE = 'bikefitting/resistance/distance',
  RESISTANCE_INSTANTANEOUS_CADENCE = 'bikefitting/resistance/indoorBikeData/instantaneousCadence',
  RESISTANCE_INSTANTANEOUS_POWER = 'bikefitting/resistance/instantaneous_power',
  RESISTANCE_LEVEL = 'bikefitting/resistance/resistance_level',
  RESISTANCE_POWER_TARGET = 'bikefitting/resistance/power_target',
  RESISTANCE_SPEED = 'bikefitting/resistance/speed',
  RESISTANCE_WHEEL_CIRCUMFRENCE = 'bikefitting/resistance/wheel_circumfrence',
  XYTOOL_BRAKES_X = 'bikefitting/XYtool/brakes/x',
  XYTOOL_BRAKES_Y = 'bikefitting/XYtool/brakes/y',
  XYTOOL_HANDLEBAR_X = 'bikefitting/XYtool/handleBar/x',
  XYTOOL_HANDLEBAR_Y = 'bikefitting/XYtool/handleBar/y',
  XYTOOL_POSITION_X = 'bikefitting/XYtool/position/x',
  XYTOOL_POSITION_Y = 'bikefitting/XYtool/position/y',
  XYTOOL_SADDLE_X = 'bikefitting/XYtool/saddle/x',
  XYTOOL_SADDLE_Y = 'bikefitting/XYtool/saddle/y',
  WEBAPP_CONNECTED = 'bikefitting/webapp/connected',
}
